import { useQuery } from '@apollo/client';
import { GET_DSP_FOR_DSP_MANAGER, GetDspForDspManagerResponse } from '../graphql/queries/getDspForDspManager';
import { getUserRole, AppRoleConstants } from '../utils/auth';

// 返回字段 isDspManager 的语义为「DSP scope 用户」（DSP_MANAGER 或 DSP_OWNER_TEAM），
// 用于按当前用户绑定的 DSP 过滤数据；保持原字段名以避免连锁修改下游消费方
export const useCurrentDsp = () => {
    const userRole = getUserRole();
    const isDspManager =
        userRole === AppRoleConstants.DSP_MANAGER ||
        userRole === AppRoleConstants.DSP_OWNER_TEAM;

    const { data, loading, error } = useQuery<GetDspForDspManagerResponse>(
        GET_DSP_FOR_DSP_MANAGER,
        {
            skip: !isDspManager, // 仅 DSP scope 用户执行查询
            errorPolicy: 'all'
        }
    );

    return {
        dspId: data?.dsp?.id || null,
        dsp: data?.dsp || null,
        loading: isDspManager ? loading : false,
        error: isDspManager ? error : null,
        isDspManager
    };
};
